import { gatewayApi } from './api';

const unwrap = (response) => response.data?.data ?? response.data;

export const assetsService = {
  async searchAssets(params = {}) {
    const response = await gatewayApi.get('/v1/assets', { params });
    return unwrap(response);
  },

  async getAsset(assetId) {
    const response = await gatewayApi.get(`/v1/assets/${assetId}`);
    return unwrap(response);
  },

  async getAssetPrice(assetId) {
    const response = await gatewayApi.get(`/v1/assets/${assetId}/price`);
    return unwrap(response);
  },

  async getBars(assetId, { resolution, from, to, countBack, signal } = {}) {
    const response = await gatewayApi.get(`/v1/assets/${assetId}/bars`, {
      params: { resolution, from, to, countBack },
      ...(signal ? { signal } : {}),
    });
    const body = unwrap(response);
    if (Array.isArray(body)) return body;
    if (Array.isArray(body?.bars)) return body.bars;
    return [];
  },

  // timeRange matches the gateway's TimeRange enum: 1h | 1d | 1w | 1m | 3m | 6m | 1y | 5y
  // Gateway body is { assetId, timeRange, data: points[] }. Do not use unwrap() —
  // that would collapse the envelope to the points array and confuse callers that
  // also read `result.data`.
  async getTimeseries(assetId, timeRange = '1m') {
    const response = await gatewayApi.get(`/v1/assets/${assetId}/timeseries`, {
      params: { timeRange },
    });
    const body = response.data;
    if (Array.isArray(body)) return body;
    if (Array.isArray(body?.data)) return body.data;
    if (Array.isArray(body?.data?.data)) return body.data.data;
    return [];
  },
};

export default assetsService;
